import { handleTokenRefresh } from "@api/authenticate";
import axios from "axios";

let isAlreadyFetchingAccessToken = false;

let subscribers = [];

// const URL = `https://newgenznbackend.herokuapp.com/` //PROD
// const URL = `https://dev-newgenzn-backend.herokuapp.com` // Dev
function resolveApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL;
  const trimmed = typeof raw === "string" ? raw.trim().replace(/^['"]|['"]$/g, "") : "";

  if (!trimmed || trimmed === "null" || trimmed === "undefined") {
    if (process.env.NODE_ENV !== "development") return "";
    return "http://127.0.0.1:8000";
  }

  return trimmed.endsWith("/") ? trimmed.slice(0, -1) : trimmed;
}

const URL = resolveApiBaseUrl(); // `https://craft-position-backend-development.onrender.com` // Dev

export const publicAxios = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const privateAxios = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

privateAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const access_token = localStorage.getItem("Token");
    const originalUrl = error?.config?.url || "";
    if (originalUrl.includes("/api/auth/refresh")) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 401 && access_token) {
      return ResetTokenAndReattemptRequest(error);
    } else {
      return Promise.reject(error);
    }
  }
);

privateAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("Token");
  if (token) {
    // or get it from localStorage
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
});

export async function ResetTokenAndReattemptRequest(error) {
  try {
    const { response: errorResponse } = error;
    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber((access_token) => {
        if (!access_token) {
          resolve(Promise.reject(error));
          return;
        }
        errorResponse.config.headers.Authorization = "Bearer " + access_token;
        resolve(axios(errorResponse.config));
      });
    });

    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;
      try {
        const response = await handleTokenRefresh();
        const newAccess = response?.data?.access;
        if (!newAccess) throw new Error("Token refresh did not return access token");
        localStorage.setItem("Token", newAccess);
        onAccessTokenFetched(newAccess);
      } catch (refreshErr) {
        // Clear tokens so the app doesn't keep retrying with a bad session.
        localStorage.removeItem("Token");
        localStorage.removeItem("RefreshToken");
        subscribers = [];
        throw refreshErr;
      } finally {
        isAlreadyFetchingAccessToken = false;
      }
    }

    return retryOriginalRequest;
  } catch (err) {
    return Promise.reject(err);
  }
}

function onAccessTokenFetched(access_token) {
  subscribers.forEach((callback) => callback(access_token));
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}
